import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

type TextColorIconProps = ComponentProps<typeof Icon> & {
  selectedColor?: string;
};

const TextColorIcon = forwardRef<SVGSVGElement, TextColorIconProps>(
  ({ selectedColor, ...props }, ref) => (
    <Icon data-testid="textColor" ref={ref} {...props}>
      <path
        fill={selectedColor}
        d="M20.985,21.5H3a1.5,1.5,0,1,1,0-3H20.985a1.5,1.5,0,0,1,0,3Z"
      />
      <path d="M19.026,15.248h-1.49l-1.98-5.11-2.87-7.41a.758.758,0,0,0-.7-.48.748.748,0,0,0-.7.48l-2.84,7.38a.108.108,0,0,0-.03.07l-1.96,5.07H4.966a.75.75,0,0,0,0,1.5h4a.75.75,0,0,0,0-1.5h-.91l1.58-4.07h4.72l1.57,4.07h-.9a.75.75,0,0,0,0,1.5h4a.75.75,0,0,0,0-1.5Zm-8.82-5.57,1.78-4.6,1.78,4.6Z" />
    </Icon>
  ),
) as IconWithRender<TextColorIconProps>;

TextColorIcon.displayName = 'TextColorIcon';
TextColorIcon.renderIcon = (props) => <TextColorIcon {...props} />;
export default TextColorIcon;
